/**
 * Reset redux state
 * @param {string} type 	type of redux action
 */
export function resetState(type) {
    return dispatch => dispatch({ type: `${type}_RESET` });
}
  
